module.exports = __webpack_public_path__ + "static/media/chk2.42bf31db.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/chk2.png
// module id = 1078
// module chunks = 0